import React, { Component } from "react"
import { Container } from "reactstrap"
import PromoTable from "./PromoTable"
import './Pricing.css'
import PromoListHeader from "./PromoListHeader"
import RestrictedSection from "../Components/RestrictedSection"
import { usePresetFilters } from '../Filters/presetFilters'

// Editable, visible default: the list opens showing active promos; the user can
// flip it to false or drop it entirely from the Advanced Filters popover/chips.
const IS_ACTIVE_PRESET = [
    { fieldName: "is_active", filterType: "equal", filterValues: "true", editable: true, visible: true },
]

class PromoContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            openModal: "",
            refetchPromo: false,
            filterValues: {},
            orderBy: ["-id"],
            selectedPromo: [],
        }
    }

    toggleModal = (name) => {
        this.setState({ openModal: this.state.openModal === name ? "" : name })
    };

    updateOrder = (string) => {
        let orderBy = [...this.state.orderBy]
        let index = orderBy.indexOf(string)
        if (index > -1) {
            orderBy[index] = "-" + string
        } else {
            index = orderBy.indexOf("-" + string)
            index > -1 ? orderBy.splice(index, 1) : orderBy.unshift(string)
        }
        this.setState({ orderBy })
    };

    render() {
        return (
            <RestrictedSection requiredPermission="view_promotiontemplate">
                <Container fluid className="pricing-list-container">
                    <PromoListHeader
                        filterValues={this.state.filterValues}
                        setFilterValues={(filterValues) => this.setState({ filterValues })}
                        refetchQuery={() => this.setState((prevState) => ({ refetchPromo: !prevState.refetchPromo }))}
                        selectedPromo={this.state.selectedPromo} location={this.props.location} history={this.props.navigate}
                        resetSelectedPromo={() => this.setState({ selectedPromo: [] })}
                        presets={this.props.presets}
                        setPresets={this.props.setPresets}
                    />
                    <PromoTable
                        key={String(this.state.refetchPromo)}
                        searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                        orderBy={this.state.orderBy}
                        presets={this.props.presets}
                    />
                </Container>
            </RestrictedSection>
        )
    }
}

// Preset state is owned here so both the header (popover + chips) and the list
// (query variables) share one source of truth.
export default function PromoContainerWithFilters(props) {
    const [presets, setPresets] = usePresetFilters(IS_ACTIVE_PRESET)
    return <PromoContainer {...props} presets={presets} setPresets={setPresets} />
}
